// extracted by mini-css-extract-plugin
export default {"cart-container":"Cart_cart-container__JjoQU","sub-container-column":"Cart_sub-container-column__Fo1HL","total-amount":"Cart_total-amount__GZM3T"};